import { render, staticRenderFns } from "./OnboardingSponsor.vue?vue&type=template&id=4a8f3743&scoped=true&"
import script from "./OnboardingSponsor.vue?vue&type=script&lang=js&"
export * from "./OnboardingSponsor.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/components/timeline/custom-timeline.css?vue&type=style&index=0&id=4a8f3743&scoped=true&lang=css&"
import style1 from "./OnboardingSponsor.vue?vue&type=style&index=1&id=4a8f3743&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f3743",
  null
  
)

export default component.exports